"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductNotificationType = exports.StoreNotificationType = exports.NotificationStatus = void 0;
var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["NEW"] = "new";
    NotificationStatus["READ"] = "read";
    NotificationStatus["RESOLVED"] = "resolved";
})(NotificationStatus = exports.NotificationStatus || (exports.NotificationStatus = {}));
var StoreNotificationType;
(function (StoreNotificationType) {
    StoreNotificationType["SELLER_HEALTH_AT_RISK"] = "SELLER_HEALTH_AT_RISK";
    StoreNotificationType["STORE_CREDENTIAL_INVALIDATION_PRIMARY"] = "STORE_CREDENTIAL_INVALIDATION_PRIMARY";
    StoreNotificationType["STORE_CREDENTIAL_INVALIDATION_ADVERTISING"] = "STORE_CREDENTIAL_INVALIDATION_ADVERTISING";
    StoreNotificationType["STORE_MISSING_PERMISSIONS"] = "STORE_MISSING_PERMISSIONS";
    StoreNotificationType["SUPPRESSED_LISTINGS_SUMMARY"] = "SUPPRESSED_LISTINGS_SUMMARY";
    StoreNotificationType["STORE_REPORT_LANGUAGE_UNSUPPORTED"] = "STORE_REPORT_LANGUAGE_UNSUPPORTED";
})(StoreNotificationType = exports.StoreNotificationType || (exports.StoreNotificationType = {}));
var ProductNotificationType;
(function (ProductNotificationType) {
    ProductNotificationType["LOST_BUYBOX"] = "LOST_BUYBOX";
    ProductNotificationType["SUPPRESSED_LISTING"] = "SUPPRESSED_LISTING";
    ProductNotificationType["LOW_INVENTORY"] = "LOW_INVENTORY";
})(ProductNotificationType = exports.ProductNotificationType || (exports.ProductNotificationType = {}));
//# sourceMappingURL=notification.js.map